import { connect } from 'react-redux';

import InSituView from '../components/GraphView/InSituView';

const mapStateToProps = state => ({
  colors: state.style.markers,
});

const InSituPage = connect(mapStateToProps)(InSituView);

export default InSituPage;
